import highEmphasis from '../text/high-emphasis';

const primary = ({ backgroundColor, whiteColor, blackColor }) =>
  highEmphasis({ backgroundColor, whiteColor, blackColor });

export default primary;
